import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as projectReducer from "containers/Project/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as loginReducer from "containers/Login/reducer";

import ModelFeedback from "components/Business/ModelBox/ModelFeedback";

class ModelFeedbackContainer extends React.PureComponent {
  render() {
    return <ModelFeedback {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateScenarioSegmentFeedback: (feedback) =>
      dispatch(projectReducer.updateScenarioSegmentFeedback(ownProps.projectId, ownProps.runId, feedback)),
    postComment: (comment) =>
      dispatch(projectReducer.postScenarioSegmentComment(ownProps.projectId, ownProps.runId, comment))
  };
};

const mapStateToProps = (state, ownProps) => {
  const runId = ownProps.runId;

  const overallRunId = projectReducer.getOverallRunId(state, ownProps.projectId);

  const segmentId = projectReducer.getSegmentId(state, ownProps.projectId, runId);

  return {
    projectSettings: projectReducer.getOptimizer(state, ownProps.projectId),
    segmentId: segmentId,
    isContinuous: setupReducer.getIsContinuous(state, runId),
    userId: loginReducer.getUserID(state),
    scenarioSegmentFeedback: projectReducer.getScenarioSegmentFeedback(state, ownProps.projectId, runId),
    setupLabels: setupReducer.getSetupLabels(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ModelFeedbackContainer);
